import { InjectionToken, Provider } from '@angular/core';
import getEnvironmentSettings from '../../commons/configs/env-conf-loader';
const ENVIRONMENT_SETTINGS = getEnvironmentSettings();

export const API_URL = new InjectionToken<string>("API_URL");
export const ApiUrlProvider: Provider = {
    provide: API_URL,
    useValue: ENVIRONMENT_SETTINGS.apiUrl
}